var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready && _vm.site)?_c('div',[_c('apexchart',{attrs:{"width":"1150","type":"line","options":_vm.options,"series":_vm.graphData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }